export const BROCHURE_URL = 'https://betterment.com';
export default (path: string) => `${BROCHURE_URL}${path}`;
